import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const MonthlyRawMaterials = React.lazy(() => import('./index'));
const MrmTable = React.lazy(() => import('./mrmTable'));
const MonthlyRawMaterial = React.lazy(() => import('./monthlyRawMaterial'));
const MrmDetail = React.lazy(() => import('./mrmDetail'));
const AddNewMonthlyRawMaterial = React.lazy(() => import('./addNewMonthlyRawMaterial'));
const EditMonthlyRawMaterial = React.lazy(() => import('./editMonthlyRawMaterial'));

export const useMonthlyRawMaterialRoutes = () => {
    return (
        <React.Fragment>
            <Route path="monthlyRawMaterial" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyRawMaterials isCumulative={false} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MrmTable isCumulative={false}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewMonthlyRawMaterial isCumulative={false}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyRawMaterial isCumulative={false}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MrmDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditMonthlyRawMaterial /></Suspense> } />
                </Route>
            </Route>
            <Route path="cumulativeMonthlyRawMaterial" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyRawMaterials isCumulative={true} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MrmTable isCumulative={true}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewMonthlyRawMaterial isCumulative={true}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyRawMaterial isCumulative={true}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MrmDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditMonthlyRawMaterial /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}